export function ThumbsUpFilledIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M20.3914 19.4562C20.1662 20.9197 18.907 22 17.4262 22H4C2.89543 22 2 21.1046 2 20V13C2 11.8954 2.89543 11 4 11H6.35013C6.74532 11 7.10344 10.7673 7.26394 10.4061L10.7831 2.48812C10.915 2.1913 11.2093 2 11.5342 2C12.896 2 14 3.10399 14 4.46584V8C14 8.55228 14.4477 9 15 9H18.5032C20.3418 9 21.7479 10.6389 21.4683 12.4562L20.3914 19.4562Z'
        fill='currentColor'
      />
      <path
        d='M7 22V11M2 13V20C2 21.1046 2.89543 22 4 22H17.4262C18.907 22 20.1662 20.9197 20.3914 19.4562L21.4683 12.4562C21.7479 10.6389 20.3418 9 18.5032 9H15C14.4477 9 14 8.55228 14 8V4.46584C14 3.10399 12.896 2 11.5342 2C11.2093 2 10.915 2.1913 10.7831 2.48812L7.26394 10.4061C7.10344 10.7673 6.74532 11 6.35013 11H4C2.89543 11 2 11.8954 2 13Z'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
